import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import { withRouter } from "react-router";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
var qs = require("qs");
var QuizEdit = /** @class */ (function (_super) {
    tslib_1.__extends(QuizEdit, _super);
    function QuizEdit(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            loading: true,
            params: { questions: [] },
            title: '',
            description: '',
            filterThemes: [],
            themeLoading: false,
            themeList: [],
        };
        return _this;
    }
    QuizEdit.prototype.componentWillMount = function () {
        if (this.props.match.params.id > 0) {
            this.Get();
        }
    };
    QuizEdit.prototype.render = function () {
        var _this = this;
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("div", { className: "m-subheader " },
                    React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                        React.createElement("div", { className: "mr-auto" },
                            React.createElement("h3", { className: "m-subheader__title " },
                                this.props.match.params.id > 0 ? 'Редактирование' : 'Создание',
                                " \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u044F")),
                        React.createElement("div", null,
                            this.props.match.params.id > 0 ? (React.createElement("button", { onClick: this.Update.bind(this), className: "btn btn-primary" }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C")) : (React.createElement("button", { onClick: this.Create.bind(this), className: "btn btn-primary" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
                            (this.props.match.params.id > 0 && this.state.status !== 'active') && (React.createElement("button", { onClick: this.SetActive.bind(this), className: "btn btn-success" }, "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C")),
                            (this.props.match.params.id > 0 && this.state.status === 'active') && (React.createElement("button", { onClick: this.SetComplete.bind(this), className: "btn btn-danger" }, "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u0435")))))),
            React.createElement("br", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("div", { className: "m-portlet m-portlet--tab" },
                        React.createElement("div", { className: "m-portlet__body" },
                            React.createElement("h3", { className: "m-portlet__head-text" }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043E\u043F\u0440\u043E\u0441\u0430"),
                            React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u043E\u043F\u0440\u043E\u0441\u0430",
                                React.createElement("input", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                                        var value = e.target.value;
                                        _this.setState({
                                            title: value,
                                        });
                                    }, value: this.state.title, type: "text" })),
                            React.createElement("br", null),
                            React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043E\u043F\u0440\u043E\u0441\u0430",
                                React.createElement("textarea", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                                        var value = e.target.value;
                                        _this.setState({
                                            description: value,
                                        });
                                    }, value: this.state.description })),
                            React.createElement("br", null),
                            React.createElement("div", { className: 'form-group', style: { width: '100%' } },
                                "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u043A \u0442\u0435\u043C\u0435",
                                React.createElement(AsyncTypeahead, { isLoading: this.state.themeLoading, labelKey: "title", options: this.state.themeList, selected: this.state.filterThemes, multiple: false, onChange: function (filterThemes) {
                                        _this.setState({ filterThemes: filterThemes });
                                    }, onSearch: function (query) {
                                        _this.setState({ themeLoading: true });
                                        fetch(API_URL + "/themes?query=" + query)
                                            .then(function (resp) { return resp.json(); })
                                            .then(function (json) { return _this.setState({
                                            themeLoading: false,
                                            themeList: json.data,
                                        }, function () { return console.log(_this.state.themeList); }); });
                                    } })),
                            React.createElement("br", null),
                            (params.questions && params.questions.length > 0) && params.questions.map(function (q, qIdx) { return (React.createElement(React.Fragment, { key: 'question-' + qIdx },
                                React.createElement("div", { className: "m-portlet m-portlet--brand m-portlet--head-solid-bg m-portlet--bordered" },
                                    React.createElement("div", { className: "m-portlet__head" },
                                        React.createElement("div", { className: "m-portlet__head-caption" },
                                            React.createElement("div", { className: "m-portlet__head-title" },
                                                React.createElement("h3", { className: "m-portlet__head-text" },
                                                    "\u0412\u043E\u043F\u0440\u043E\u0441 ",
                                                    qIdx + 1))),
                                        React.createElement("div", { className: "m-portlet__head-tools" },
                                            React.createElement("ul", { className: "m-portlet__nav" },
                                                React.createElement("li", { className: "m-portlet__nav-item" },
                                                    React.createElement("button", { onClick: _this.removeQuestion.bind(_this, qIdx), className: "btn btn-error" }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441"))))),
                                    React.createElement("div", { className: "m-portlet__body" },
                                        React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                            "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0430 ",
                                            qIdx + 1,
                                            React.createElement("input", { className: "form-control cols-xs-12", name: 'name-' + qIdx, onChange: function (e) {
                                                    params.questions[qIdx].title = e.target.value;
                                                    _this.setState({
                                                        params: params,
                                                    });
                                                }, value: params.questions[qIdx].title, type: "text" })),
                                        React.createElement("br", null),
                                        React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                            "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u0430 ",
                                            qIdx + 1,
                                            React.createElement("textarea", { className: "form-control cols-xs-12", name: 'desc-' + qIdx, onChange: function (e) {
                                                    params.questions[qIdx].description = e.target.value;
                                                    _this.setState({
                                                        params: params,
                                                    });
                                                }, value: params.questions[qIdx].description })),
                                        React.createElement("br", null),
                                        params.questions[qIdx].answers.map(function (ans, idx) { return (React.createElement(React.Fragment, { key: 'q-' + qIdx + '-a-' + idx },
                                            React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                                "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 ",
                                                idx + 1,
                                                React.createElement("span", { style: { float: 'right', cursor: 'pointer', color: 'red' }, onClick: _this.delAnswer.bind(_this, qIdx, idx) }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"),
                                                React.createElement("input", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                                                        params.questions[qIdx].answers[idx].title = e.target.value;
                                                        _this.setState({
                                                            params: params
                                                        });
                                                    }, value: ans.title, type: "text" }),
                                                React.createElement("input", { style: { width: '15px', height: '15px', display: 'inline-block' }, className: "form-control cols-xs-12", name: "unique", onChange: function (e) {
                                                        params.questions[qIdx].answers[idx].unique_answer = !params.questions[qIdx].answers[idx].unique_answer;
                                                        _this.setState({
                                                            params: params
                                                        });
                                                    }, checked: ans.unique_answer, type: "checkbox" }),
                                                "\u0418\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439\u00A0\u00A0\u00A0",
                                                React.createElement("input", { style: { width: '15px', height: '15px', display: 'inline-block' }, className: "form-control cols-xs-12", name: "custom", onChange: function (e) {
                                                        params.questions[qIdx].answers[idx].custom_answer = !params.questions[qIdx].answers[idx].custom_answer;
                                                        _this.setState({
                                                            params: params
                                                        });
                                                    }, checked: ans.custom_answer, type: "checkbox" }),
                                                "\u0421\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0439 \u0432\u0432\u043E\u0434"),
                                            React.createElement("br", null))); }),
                                        React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                            React.createElement("button", { onClick: _this.addAnswer.bind(_this, qIdx), className: "btn btn-info" },
                                                "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 ",
                                                qIdx + 1)),
                                        React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                            "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
                                            React.createElement("input", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                                                    params.questions[qIdx].min_answers = e.target.value;
                                                    _this.setState({
                                                        params: params
                                                    });
                                                }, value: params.questions[qIdx].min_answers, type: "number" })),
                                        React.createElement("br", null),
                                        React.createElement("div", { className: "form-group", style: { width: '100%' } },
                                            "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
                                            React.createElement("input", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                                                    params.questions[qIdx].max_answers = e.target.value;
                                                    _this.setState({
                                                        params: params
                                                    });
                                                }, value: params.questions[qIdx].max_answers, type: "number" })))))); })),
                        React.createElement("div", { className: "m-portlet__foot" },
                            React.createElement("div", { className: "row align-items-center" },
                                React.createElement("div", { className: "col-lg-12" },
                                    React.createElement("button", { onClick: this.addQuestion.bind(this), className: "btn btn-success" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441")))))))));
    };
    QuizEdit.prototype.removeQuestion = function (qId) {
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        params.questions.splice(qId, 1);
        this.setState({ params: params });
    };
    QuizEdit.prototype.Get = function () {
        var _this = this;
        axios.get(API_URL + "/quiz/" + this.props.match.params.id).then(function (r) {
            if (r.data && r.data.data && r.data.code === 200) {
                _this.setState(tslib_1.__assign({}, r.data.data), function () {
                    if (_this.state.theme_id && _this.state.theme_id > 0) {
                        axios.get(API_URL + "/theme/" + _this.state.theme_id).then(function (resp) {
                            if (resp.data && resp.data.data && resp.data.code === 200) {
                                var filterThemes = [];
                                filterThemes.push(resp.data.data);
                                _this.setState({ filterThemes: filterThemes });
                            }
                        });
                    }
                });
            }
        }).catch(function (e) {
            console.log(e);
        });
    };
    QuizEdit.prototype.Create = function () {
        var _this = this;
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        if (this.state.title.length < 1) {
            toastr.error("Ошибка", "Отсутствует заголовок голосования");
            return;
        }
        if (!this.state.filterThemes[0] || this.state.filterThemes[0].id < 1) {
            toastr.error("Ошибка", "Необходимо привязать опрос к теме");
            return;
        }
        if (!params || !params.questions || params.questions.length < 1) {
            toastr.error("Ошибка", "Нет ни одного вопроса для голосования");
            return;
        }
        var gFlag = false;
        params.questions.forEach(function (q, qIdx) {
            if (q.title.length < 1) {
                toastr.error("Ошибка", "Нет заголовка в вопросе " + (qIdx + 1).toString());
                gFlag = true;
                return;
            }
            if (!params.questions[qIdx].answers || !params.questions[qIdx].answers[0]) {
                toastr.error("Ошибка", "Нет ни одного варианта ответа в вопросе " + (qIdx + 1).toString());
                gFlag = true;
                return;
            }
            else {
                if (params.questions[qIdx].min_answers > params.questions[qIdx].max_answers) {
                    toastr.error("Ошибка", "Минимальное кол-во ответов не может быть больше максимального в вопросе " + (qIdx + 1).toString());
                    gFlag = true;
                    return;
                }
                if (params.questions[qIdx].min_answers < 0 || params.questions[qIdx].max_answers < 0) {
                    toastr.error("Ошибка", "Кол-во ответов не может быть отрицательным в вопросе " + (qIdx + 1).toString());
                    gFlag = true;
                    return;
                }
                var flag_1 = false;
                q.answers.forEach(function (a, idx) {
                    if (a.title.length < 1) {
                        flag_1 = true;
                        toastr.error("Ошибка", "Не заполнен вариант " + (idx + 1).toString() + " в вопросе " + (qIdx + 1).toString());
                    }
                });
                if (flag_1) {
                    gFlag = true;
                    return;
                }
            }
        });
        if (gFlag) {
            return;
        }
        axios.post(API_URL + "/quiz", qs.stringify({
            title: this.state.title,
            description: this.state.description,
            theme_id: this.state.filterThemes[0] ? this.state.filterThemes[0].id : null,
            params: (typeof this.state.params === 'string') ? this.state.params : JSON.stringify(this.state.params),
        }), { headers: { 'Authorization': this.props.auth_token } })
            .then(function (r) {
            if (r.data && r.data.code && Number(r.data.code) === 201) {
                toastr.success("Успех", "Голосование создано");
                _this.props.history.push('/quizzes/');
            }
        }).catch(function (e) { return console.log(e); });
    };
    QuizEdit.prototype.Update = function () {
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        if (this.state.title.length < 1) {
            toastr.error("Ошибка", "Отсутствует заголовок голосования");
            return;
        }
        if (!this.state.filterThemes[0] || this.state.filterThemes[0].id < 1) {
            toastr.error("Ошибка", "Необходимо привязать опрос к теме");
            return;
        }
        if (!params || !params.questions || params.questions.length < 1) {
            toastr.error("Ошибка", "Нет ни одного вопроса для голосования");
            return;
        }
        var gFlag = false;
        params.questions.forEach(function (q, qIdx) {
            if (q.title.length < 1) {
                toastr.error("Ошибка", "Нет заголовка в вопросе " + (qIdx + 1).toString());
                gFlag = true;
                return;
            }
            if (!params.questions[qIdx].answers || !params.questions[qIdx].answers[0]) {
                toastr.error("Ошибка", "Нет ни одного варианта ответа в вопросе " + (qIdx + 1).toString());
                gFlag = true;
                return;
            }
            else {
                if (params.questions[qIdx].min_answers > params.questions[qIdx].max_answers) {
                    toastr.error("Ошибка", "Минимальное кол-во ответов не может быть больше максимального в вопросе " + (qIdx + 1).toString());
                    gFlag = true;
                    return;
                }
                if (params.questions[qIdx].min_answers < 0 || params.questions[qIdx].max_answers < 0) {
                    toastr.error("Ошибка", "Кол-во ответов не может быть отрицательным в вопросе " + (qIdx + 1).toString());
                    gFlag = true;
                    return;
                }
                var flag_2 = false;
                q.answers.forEach(function (a, idx) {
                    if (a.title.length < 1) {
                        flag_2 = true;
                        toastr.error("Ошибка", "Не заполнен вариант " + (idx + 1).toString() + " в вопросе " + (qIdx + 1).toString());
                    }
                });
                if (flag_2) {
                    gFlag = true;
                    return;
                }
            }
        });
        if (gFlag) {
            return;
        }
        axios.put(API_URL + "/quiz/" + this.props.match.params.id, qs.stringify({
            title: this.state.title,
            description: this.state.description,
            theme_id: this.state.filterThemes[0] ? this.state.filterThemes[0].id : null,
            params: (typeof this.state.params === 'string') ? this.state.params : JSON.stringify(this.state.params),
        }), { headers: { 'Authorization': this.props.auth_token } })
            .then(function (r) {
            if (r.data && r.data.code && Number(r.data.code) === 200) {
                toastr.success("Успех", "Голосование обновлено");
            }
        }).catch(function (e) { return console.log(e); });
    };
    QuizEdit.prototype.SetActive = function () {
        var _this = this;
        if (confirm("Вы действительно хотите сделать данное голосование активным?")) {
            axios.post(API_URL + "/quiz/active/" + this.props.match.params.id, {}, { headers: { 'Authorization': this.props.auth_token } })
                .then(function (r) {
                if (r.data && r.data.code && Number(r.data.code) === 200) {
                    toastr.success("Успех", "Голосование активно");
                    _this.setState({ status: 'active' });
                }
            }).catch(function (e) { return console.log(e); });
        }
    };
    QuizEdit.prototype.SetComplete = function () {
        var _this = this;
        if (confirm("Вы действительно хотите завершить голосование?")) {
            axios.post(API_URL + "/quiz/complete/" + this.props.match.params.id, {}, { headers: { 'Authorization': this.props.auth_token } })
                .then(function (r) {
                if (r.data && r.data.code && Number(r.data.code) === 200) {
                    toastr.success("Успех", "Голосование снято с публикации");
                    _this.setState({ status: 'complete' });
                }
            }).catch(function (e) { return console.log(e); });
        }
    };
    /*private ShowResults() {
      if (confirm("Вы действительно хотите вывести результаты на сайт?")) {
        axios.post(API_URL + "/quiz/show-results/" + this.props.match.params.id, {},
          {headers: {'Authorization': this.props.auth_token }})
          .then(r => {
            if (r.data && r.data.code && Number(r.data.code) === 200) {
              toastr.success("Успех", "Результаты выведены");
              this.setState({show_results: true});
            }
          }).catch(e => console.log(e));
      }
    }*/
    /*private UnShowResults() {
      if (confirm("Вы действительно хотите убрать результаты с сайта?")) {
        axios.post(API_URL + "/quiz/show-results/" + this.props.match.params.id, qs.stringify({cancel: true}),
          {headers: {'Authorization': this.props.auth_token }})
          .then(r => {
            if (r.data && r.data.code && Number(r.data.code) === 200) {
              toastr.success("Успех", "Результаты скрыты");
              this.setState({show_results: false});
            }
          }).catch(e => console.log(e));
      }
    }*/
    QuizEdit.prototype.addQuestion = function () {
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        var line = 'Заголовок вопроса ' + (params.questions.length + 1);
        var code = 'Q' + (params.questions.length + 1);
        params.questions.push({
            title: '',
            placeholder: line,
            description: '',
            guid: guid(),
            code: code,
            max_answers: 0,
            min_answers: 0,
            answers: [],
            image: '',
            required: true,
            shuffle: false,
            type: 'checkbox',
            weight: params.questions.length + 1,
        });
        this.setState({ params: params });
        return params;
    };
    QuizEdit.prototype.addAnswer = function (qIdx) {
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        if (!params.questions || params.questions.length < 1) {
            params = this.addQuestion();
        }
        var code = 'A' + (params.questions[qIdx].answers.length + 1);
        params.questions[qIdx].answers.push({
            title: '',
            placeholder: 'Ответ ' + (params.questions[qIdx].answers.length + 1),
            description: '',
            code: code,
            type: 'checkbox',
            weight: params.questions[qIdx].answers.length + 1,
            guid: guid(),
            unique_answer: false,
            custom_answer: false,
            shuffle: false,
        });
        this.setState({ params: params });
    };
    QuizEdit.prototype.delAnswer = function (qIdx, idx) {
        var params = (typeof this.state.params === 'string') ? JSON.parse(this.state.params) : this.state.params;
        params.questions[qIdx].answers.splice(idx, 1);
        this.setState({ params: params });
    };
    return QuizEdit;
}(React.Component));
function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(QuizEdit));



//////////////////
// WEBPACK FOOTER
// ./src/views/quizzes/edit.tsx
// module id = 540
// module chunks = 0